import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "w-full col-span-2" }
const _hoisted_3 = ["disabled", "title"]
const _hoisted_4 = {
  key: 0,
  class: "icon-pdf"
}
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = {
  key: 0,
  class: "detailRegion"
}
const _hoisted_7 = {
  key: 0,
  class: "flex locationDetailRow"
}
const _hoisted_8 = { class: "detailAttribute" }
const _hoisted_9 = { class: "flex locationDetailRow" }
const _hoisted_10 = { class: "detailAttribute" }
const _hoisted_11 = { class: "flex locationDetailRow" }
const _hoisted_12 = { class: "detailAttribute" }
const _hoisted_13 = { class: "grid grid-cols-2 gap-4 w-full mt-4" }
const _hoisted_14 = { class: "detailRegion" }
const _hoisted_15 = { class: "flex locationDetailRow" }
const _hoisted_16 = { class: "detailAttribute" }
const _hoisted_17 = { class: "flex locationDetailRow" }
const _hoisted_18 = { class: "detailAttribute" }
const _hoisted_19 = { class: "flex locationDetailRow" }
const _hoisted_20 = { class: "detailAttribute" }
const _hoisted_21 = { class: "flex locationDetailRow" }
const _hoisted_22 = { class: "detailAttribute" }
const _hoisted_23 = { class: "flex locationDetailRow" }
const _hoisted_24 = { class: "detailAttribute" }
const _hoisted_25 = { class: "flex locationDetailRow" }
const _hoisted_26 = { class: "detailAttribute" }
const _hoisted_27 = { class: "detailRegion" }
const _hoisted_28 = { class: "flex locationDetailRow" }
const _hoisted_29 = { class: "detailAttribute" }
const _hoisted_30 = { class: "flex locationDetailRow" }
const _hoisted_31 = { class: "detailAttribute" }
const _hoisted_32 = { class: "text-center" }

import {computed, onMounted, ref} from "vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {LocationService} from "@/utilities/services/entities/LocationService";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import {LocationInfo} from "@/models/location/LocationInfo";
import {DisdiInfo} from "@/models/disdi/DisdiInfo";
import DateToStringHelper from "@/utilities/helpers/DateToStringHelper";
import {$t} from "@/utilities/i18n/config";
import {DisdiService} from "@/utilities/services/entities/DisdiService";
import {useGlobalStore} from "@/stores/GlobalStore";
import {CategoryService} from "@/utilities/services/entities/CategoryService";
import {CategoryInfo} from "@/models/category/CategoryInfo";
import moment from "moment/moment";



export default /*@__PURE__*/_defineComponent({
  __name: 'DisdiDetailTab',
  props: {
  data: DisdiInfo
},
  setup(__props) {

const props = __props;

const globalStore = useGlobalStore();

const locationService = new LocationService();
const disdiService = new DisdiService();
const categoryService = new CategoryService();

const contextLocation = ref<LocationInfo|null>(null);
const contextCategory = ref<CategoryInfo|undefined>(undefined);

const regStartString = computed(()=> props.data.registrationStart !== null
    ? DateToStringHelper(new Date (props.data.registrationStart))
    : "");
const regEndString = computed(()=> props.data.registrationEnd !== null
    ? DateToStringHelper(new Date(props.data.registrationEnd))
    : "");

const loading = ref<boolean>(false);
const downloadingPdf = ref<boolean>(false);

const getDetailedData = async()=>{
  contextLocation.value = await locationService.getLocationBySecondaryId(props.data.locationSecondaryId, ErrorLocationType.popup);
  contextCategory.value = (await categoryService.getCategories("display", ErrorLocationType.popup))?.find(c => c.id === props.data.categoryId);
}

const getPdf = async () => {
  downloadingPdf.value = true;

  const disdiIds = [props.data.id];

  const success = await disdiService.exportPdf(disdiIds, ErrorLocationType.table);
  if(success) globalStore.showSuccess($t('disdi.view.pdfDownloaded'));

  downloadingPdf.value = false;
};

onMounted(async()=>{
  loading.value = true;
  await getDetailedData();
  loading.value = false;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "primary mr-2 float-right",
          disabled: downloadingPdf.value,
          onClick: getPdf,
          title: _unref($t)('global.downloadPdf')
        }, [
          (!downloadingPdf.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
            : (_openBlock(), _createBlock(LoadingSpinner, { key: 1 }))
        ], 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (contextLocation.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_unref($t)('popups.disdiDetails.atbTitle')), 1),
              _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
              (contextCategory.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_unref($t)('popups.disdiDetails.category')), 1),
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(contextCategory.value.title) + " (", 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(`icon-${contextCategory.value.iconName}`)
                      }, null, 2),
                      _cache[0] || (_cache[0] = _createTextVNode(")"))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref($t)('popups.disdiDetails.description')), 1),
                _createElementVNode("div", null, _toDisplayString(props.data.diaryDescription), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_unref($t)('popups.disdiDetails.createDate')), 1),
                _createElementVNode("div", null, _toDisplayString(_unref(moment)(props.data.createDate).format('DD.MM.YYYY HH:mm')), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createTextVNode(_toDisplayString(_unref($t)('popups.disdiDetails.user.title')), 1),
          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_unref($t)('popups.disdiDetails.user.fullName')), 1),
            _createElementVNode("div", null, _toDisplayString(props.data.userFullname), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref($t)('popups.disdiDetails.user.email')), 1),
            _createElementVNode("div", null, _toDisplayString(props.data.userEmail), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(_unref($t)('popups.disdiDetails.user.phoneNumber')), 1),
            _createElementVNode("div", null, _toDisplayString(props.data.userPhoneNumber), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, _toDisplayString(_unref($t)('popups.disdiDetails.user.identificationNumber')), 1),
            _createElementVNode("div", null, _toDisplayString(props.data.identificationNumber), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, _toDisplayString(_unref($t)('popups.disdiDetails.user.kid')), 1),
            _createElementVNode("div", null, _toDisplayString(props.data.kid), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, _toDisplayString(_unref($t)('popups.disdiDetails.user.company')), 1),
            _createElementVNode("div", null, _toDisplayString(props.data.companyName), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createTextVNode(_toDisplayString(_unref($t)('popups.disdiDetails.registration')), 1),
          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
          _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, _toDisplayString(_unref($t)('popups.disdiDetails.registrationStart')), 1),
            _createElementVNode("div", null, _toDisplayString(regStartString.value), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, _toDisplayString(_unref($t)('popups.disdiDetails.registrationEnd')), 1),
            _createElementVNode("div", null, _toDisplayString(regEndString.value), 1)
          ])
        ])
      ])
    ], 512), [
      [_vShow, !loading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_32, [
      _createVNode(LoadingSpinner)
    ], 512), [
      [_vShow, loading.value]
    ])
  ], 64))
}
}

})